import { CurrencyStyled } from '@components/PriceLabel/components/styled';
import { styled } from '@linaria/react';

export const PriceWrapper = styled.span`
  font-size: inherit;
`;

export const CurrencyWrapper = styled(CurrencyStyled)`
  font-size: inherit;
`;
